import { render } from "./AddActivityTracking.vue?vue&type=template&id=e2dae814&scoped=true"
import script from "./AddActivityTracking.vue?vue&type=script&lang=js"
export * from "./AddActivityTracking.vue?vue&type=script&lang=js"

import "./AddActivityTracking.vue?vue&type=style&index=0&id=e2dae814&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2dae814"]])

export default __exports__